export default __webpack_public_path__ + "static/media/fortnitelol.ff113aeb.png";